import type React from 'react';
import styles from './PageHeader.module.scss';

export type PageHeaderProps = {
  text: string;
  centered?: boolean;
  sideNode?: React.ReactNode;
  level?: 1 | 2;
  'data-testid'?: string;
};

function PageHeader({ text, centered = false, sideNode, level = 1, 'data-testid': dataTestId }: PageHeaderProps) {
  const HTag = `h${level}` as const;
  return (
    <div className={headerWrapperClass({ centered, sideNode, currentStyles: styles })}>
      <HTag className={styles.title} data-testid={dataTestId || 'page-heading'}>
        {text}
      </HTag>
      {sideNode}
    </div>
  );
}

function headerWrapperClass({
  centered,
  sideNode,
  currentStyles,
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
}: { centered?: boolean; sideNode?: React.ReactNode; currentStyles: any }) {
  if (sideNode) return currentStyles.spaceBetween;
  if (centered) return currentStyles.centered;
  return '';
}

export default PageHeader;
